<div class="welcome-container darkWhiteBG50 dFlex fCol alignItemsCenter">
  <div class="welcome dFlex justifyContentCenter">
    <div class="welcome-header dFlex fCol primaryBG">
      <a routerLink="/" class="logo white marTop25 marLeft20 marRight20 dFlex"></a>

      <hr class="whiteBG mar20 marLeft40 marRight40 opat25" />
      <div class="whiteT marLeft20 marRight20">
        <div>
          <h1 class="w300 marBot20">Welcome to SimpleCitizen</h1>
        </div>
      </div>
    </div>

    <div class="mainBody noPad whiteBG dFlex">
      <div class="width100 pad30" [ngSwitch]="focus">
        <section class="pageTitle tAlignLeft" *ngSwitchDefault>
          <h3 class="darkGrey w300 tAlignCenter">Sign In</h3>
          <hr class="darkWhiteBG marTop20 marBot20 opat25" />

          <form
            #emailPasswordForm
            [formGroup]="loginForm"
            [action]="nextPath ? '/auth/complete/email/?next=' + nextPath : '/auth/complete/email/'"
            method="post"
            (ngSubmit)="passwordRequired ? submitEmailPasswordForm(emailPasswordForm) : checkEmail($event)"
          >
            <!-- We have to have these hidden/disabled fields to prevent password managers from
              autofilling the email address and resetting the form.
             -->
            <input
              type="email"
              [name]="enablePasswordManagerBypass ? 'email' : 'hidden-disabled-email'"
              hidden
              disabled
            />
            <input
              type="password"
              [name]="enablePasswordManagerBypass ? 'password' : 'hidden-disabled-password'"
              hidden
              disabled
            />
            <label class="marTop25">
              <input
                #emailField
                type="email"
                id="email"
                [name]="enablePasswordManagerBypass ? 'disabled-email-field' : 'email'"
                class="field auth-field lightGreyBG50"
                (focus)="emailFieldFocused = true"
                (blur)="emailFieldFocused = false"
                [class.is-empty]="!loginForm.get('email').value"
                [autocomplete]="passwordRequired ? 'off' : 'on'"
                formControlName="email"
              />
              <span>
                <span class="dFlex justifyContentCenter">
                  <fa-icon [icon]="['far', 'envelope']" class="marRight5"></fa-icon> Email <em class="required">*</em>
                </span>
              </span>
            </label>

            <label class="marTop25" *ngIf="passwordRequired">
              <input
                #passwordField
                type="password"
                id="password"
                [name]="enablePasswordManagerBypass ? 'disabled-password-field' : 'password'"
                class="field auth-field lightGreyBG50"
                [class.is-empty]="!loginForm.get('password').value"
                formControlName="password"
                [required]="passwordRequired"
              />
              <span>
                <span class="dFlex justifyContentCenter">
                  <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> Password <em class="required">*</em>
                </span>
              </span>
            </label>

            <div class="marTop25 marBot10">
              <input
                type="checkbox"
                class="checkmark"
                id="rememberUsername"
                name="rememberUsername"
                formControlName="rememberUsername"
              />
              <label for="rememberUsername" class="noPad dFlex justifyContentFlexStart alignItemsCenter">
                <div class="absolute marLeft40 dFlex fCol justifyContentFlexStart alignItemsFlexStart">
                  <p class="noMar">Remember my username</p>
                  <p class="fs-875 medGreyT noMar">Do not select this option on a public device</p>
                </div>
              </label>
            </div>

            <p class="redT" *ngIf="errorMsg">{{ errorMsg }}</p>

            <section class="buttonGroupBottom tAlignCenter clearfix">
              <button
                id="loginSubmit"
                class="button primary radius noMar marTop20 primaryBorder left width100"
                type="submit"
              >
                <fa-icon [icon]="['far', 'sign-in-alt']"></fa-icon>
                Login
              </button>
            </section>

            <ng-container *ngIf="passwordRequired">
              <hr class="darkWhiteBG marTop20 marBot20 opat25" />

              <div class="tAlignCenter">
                <a
                  [routerLink]="['/forgot-password']"
                  [queryParams]="{ email: loginForm.get('email').value, next: this.nextPath }"
                  class="primaryT w400 marTop20 button right"
                >
                  Forgot your password?
                </a>
              </div>
            </ng-container>
          </form>
        </section>

        <section class="pageTitle tAlignLeft" *ngSwitchCase="'forgotpassword'">
          <h3 class="darkGrey w300 tAlignLeft">Forgot Password?</h3>
          <p class="darkGrey w300 tAlignLeft">
            Confirm your email address and we’ll send you instructions to reset your password.
          </p>
          <hr class="darkWhiteBG marTop20 marBot20 opat25" />

          <form #forgotPasswordForm="ngForm" (ngSubmit)="forgotPassword()">
            <label class="marTop25 oneColumn">
              <input
                type="text"
                id="forgotPasswordEmail"
                name="forgotPasswordEmail"
                class="field auth-field lightGreyBG50"
                [class.is-empty]="!forgotPasswordEmail"
                [(ngModel)]="forgotPasswordEmail"
                required
              />
              <span>
                <span class="dFlex justifyContentCenter">
                  <fa-icon [icon]="['far', 'envelope']" class="marRight5"></fa-icon> Email <em class="required">*</em>
                </span>
              </span>
            </label>

            <p class="redT" *ngIf="errorMsg">{{ errorMsg }}</p>

            <section class="buttonGroupBottom tAlignCenter clearfix">
              <button class="button primary radius primaryBorder noMar marTop20 left width100" type="submit">
                <fa-icon [icon]="['far', 'lock']"></fa-icon>
                Reset Password
              </button>
            </section>

            <hr class="darkWhiteBG marTop20 marBot20 opat25" />

            <div class="marTop20 tAlignCenter">
              <a
                [routerLink]="['/welcome']"
                [queryParams]="{ email: emailText === forgotPasswordEmail ? emailText : null }"
                class="primaryT w400 marTop20 button right"
              >
                Remember your password?
              </a>
            </div>
          </form>
        </section>

        <section class="pageTitle tAlignLeft" *ngSwitchCase="'newpassword'">
          <ng-container [ngSwitch]="changePasswordMessageType">
            <ng-container *ngSwitchDefault>
              <h3 class="darkGrey w300 tAlignLeft">Set New Password.</h3>
              <p class="darkGrey w300 tAlignLeft">Create a new password.</p>
            </ng-container>
            <ng-container *ngSwitchCase="'create'">
              <h3 class="darkGrey w300 tAlignLeft">Set Initial Password.</h3>
              <p class="darkGrey w300 tAlignLeft">
                <span *ngIf="!useSso">Create an initial password for your account.</span>
                <span *ngIf="useSso">Login via SSO</span>
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'business-terms'">
              <h3 class="darkGrey w300 tAlignLeft">
                <span *ngIf="!useSso">Set Initial Password</span>
                <span *ngIf="useSso">Welcome</span>
              </h3>
              <p class="darkGrey w300 tAlignLeft">
                You have been invited to use SimpleCitizen through an immigration law firm.
                <span *ngIf="!useSso" class="dInline w300">Please create a password for your account.</span>
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'rafiki-terms'">
              <h3 class="darkGrey w300 tAlignLeft">
                <span *ngIf="!useSso">Set Initial Password</span>
                <span *ngIf="useSso">Welcome</span>
              </h3>
              <p class="darkGrey w300 tAlignLeft">
                You have been invited to use Rafiki.
                <span *ngIf="!useSso" class="dInline w300">Please create a password for your account.</span>
              </p>
            </ng-container>
          </ng-container>

          <hr class="darkWhiteBG marTop20 marBot20 opat25" />

          <ul *ngIf="passwordRequirements">
            <li class="medGreyT" *ngFor="let requirement of passwordRequirements">
              {{ requirement.helpText }}
            </li>
          </ul>

          <!-- <p class="medGreyT w400 marTop10 noMarBot">
                          Contact your administrator if you have trouble logging in
                      </p> -->

          <form #setNewPasswordForm="ngForm" (ngSubmit)="setNewPassword()">
            <label *ngIf="!useSso" class="marTop25">
              <input
                type="password"
                id="setNewPasswordText"
                name="setNewPasswordText"
                class="field auth-field lightGreyBG50"
                [(ngModel)]="setNewPasswordText"
                [class.is-empty]="!setNewPasswordText"
                [class.is-valid]="setNewPasswordText === setRetypeNewPasswordText && setNewPasswordText"
                [class.is-not-valid]="setNewPasswordText !== setRetypeNewPasswordText && startApplicationPasswordText"
                #newPasswordText="ngModel"
                required
              />
              <span>
                <span class="dFlex justifyContentCenter">
                  <ng-container [ngSwitch]="changePasswordMessageType">
                    <ng-container *ngSwitchDefault>
                      <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> New Password
                      <em class="required">*</em>
                    </ng-container>
                    <ng-container *ngSwitchCase="'create'">
                      <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> Password <em class="required">*</em>
                    </ng-container>
                    <ng-container *ngSwitchCase="'business-terms'">
                      <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> Password <em class="required">*</em>
                    </ng-container>
                    <ng-container *ngSwitchCase="'rafiki-terms'">
                      <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> Password <em class="required">*</em>
                    </ng-container>
                  </ng-container>
                </span>
              </span>
            </label>

            <label *ngIf="!useSso" class="marTop25">
              <input
                type="password"
                id="setRetypeNewPasswordText"
                name="setRetypeNewPasswordText"
                class="field auth-field lightGreyBG50"
                [class.is-empty]="!setRetypeNewPasswordText"
                [(ngModel)]="setRetypeNewPasswordText"
                [class.is-valid]="setNewPasswordText === setRetypeNewPasswordText && setRetypeNewPasswordText"
                [class.is-not-valid]="setNewPasswordText !== setRetypeNewPasswordText && setRetypeNewPasswordText"
                required
              />
              <span>
                <span class="dFlex justifyContentCenter">
                  <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> Verify <em class="required">*</em>
                </span>
              </span>
            </label>

            <div
              *ngIf="changePasswordMessageType === 'business-terms' || changePasswordMessageType === 'rafiki-terms'"
              [class.marTop40]="!useSso"
              class="scRadioCheckbox"
            >
              <p class="noMar">
                <input
                  type="checkbox"
                  name="acceptTerms"
                  id="acceptTerms"
                  required
                  [(ngModel)]="acceptedTermsAndConditions"
                />
                <label class="smText dFlex alignItemsCenter" for="acceptTerms">
                  I Accept The Terms and Conditions
                </label>
              </p>
              <p class="medGreyT noMar">
                <span class="tinyText">
                  <a
                    *ngIf="changePasswordMessageType === 'business-terms'"
                    class="primaryT clickable"
                    href="https://simplecitizen.com/terms-and-conditions/"
                    target="_blank"
                  >
                    Terms and Conditions
                  </a>
                  <a
                    *ngIf="changePasswordMessageType === 'rafiki-terms'"
                    class="primaryT clickable"
                    href="https://simplecitizen.com/terms-of-service-rafiki/"
                    target="_blank"
                    >Terms and Conditions</a
                  >
                </span>
              </p>
            </div>

            <p class="redT" *ngIf="errorMsg">{{ errorMsg }}</p>

            <p
              class="redT"
              *ngIf="setNewPasswordText && setRetypeNewPasswordText && setNewPasswordText !== setRetypeNewPasswordText"
            >
              Passwords do not match
            </p>

            <section *ngIf="!useSso" class="buttonGroupBottom tAlignCenter clearfix">
              <button
                class="button primary radius dropShadow marTop20 left"
                [disabled]="
                  !(
                    setNewPasswordText &&
                    setRetypeNewPasswordText &&
                    setNewPasswordText === setRetypeNewPasswordText
                  ) ||
                  changePasswordMessageType === 'business-terms' ||
                  (changePasswordMessageType === 'rafiki-terms' && !acceptedTermsAndConditions) ||
                  loading
                "
                type="submit"
              >
                <fa-icon [icon]="['far', 'save']"></fa-icon>
                Save
              </button>
            </section>

            <section *ngIf="useSso" class="buttonGroupBottom tAlignCenter clearfix">
              <button
                class="button primary radius dropShadow marTop20 left"
                [disabled]="!acceptedTermsAndConditions || loading"
                type="submit"
              >
                <fa-icon [icon]="['far', 'save']"></fa-icon>
                Login
              </button>
            </section>
          </form>
        </section>
      </div>

      <form class="dNone" action="/auth/complete/email/" method="post" #loginAfterForm>
        <input type="hidden" name="email" [value]="loginAfterEmailText" />
        <input type="hidden" name="password" [value]="loginAfterPasswordText" />
      </form>
    </div>
  </div>
</div>
